<template>
  <span class="reference-cell d-inline-flex align-items-center">
    <i :class="[typeIcon, 'text-muted', 'mr-2']" style="font-size:0.9rem;" :title="row.type" aria-hidden="true"></i>
    {{ value }}
  </span>
</template>

<script>
const TYPE_ICONS = {
  Invoice: 'fas fa-file-alt',
  'Credit Note': 'fas fa-file-minus',
  Refund: 'fas fa-undo',
  Payment: 'fas fa-credit-card'
}

export default {
  name: 'ReferenceCell',

  props: {
    value: {
      type: String,
      required: true
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    typeIcon () {
      return TYPE_ICONS[this.row.type] || 'fas fa-file'
    }
  }
}
</script>
